import React, { ChangeEvent, FC } from 'react'
import { FieldProps } from 'formik'
import { currencySymbols } from '@shared/config'
import { InputProps } from '@shared/ui/molecules'
import InputField from './InputField'

type MoneyInputFieldProps = Omit<InputProps, 'value' | 'onChange' | 'onBlur' | 'error' | 'suffix'> & FieldProps

const MoneyInputField: FC<MoneyInputFieldProps> = ({ field, ...props }) => (
  <InputField
    {...props}
    field={{
      ...field,
      onChange: (event: ChangeEvent<HTMLInputElement>) => {
        event.target.value = event.target.value.replace(/\D/g, '')
        field.onChange(event)
      },
    }}
    suffix={currencySymbols.RUB}
    inputMode="numeric"
  />
)

export default MoneyInputField
